import React, { Component } from 'react';
import PropTypes from 'prop-types';
import VerbButton, { VERB_BUTTON_TYPE } from '../VerbButton';

class PromptModal extends Component {
    static propTypes = {
        title: PropTypes.string,
        promptText: PropTypes.string,
        handleButtonClick: PropTypes.func,
        confirmationButtonText: PropTypes.string,
        cancelButtonText: PropTypes.string,
        className: PropTypes.string
    };

    render() {
        const { title, promptText, handleButtonClick, confirmationButtonText, cancelButtonText, className } =
            this.props;
        return (
            <div className={className}>
                <h5>{title}</h5>
                <p style={{ whiteSpace: 'pre' }}>{promptText}</p>
                <div className={'row'}>
                    <VerbButton
                        onClick={() => {
                            handleButtonClick(true);
                        }}
                        className={'ms-auto'}
                        buttonText={confirmationButtonText}
                    />
                    &nbsp;
                    <VerbButton
                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                        onClick={() => {
                            handleButtonClick(false);
                        }}
                        buttonText={cancelButtonText}
                        className={'me-auto'}
                    />
                </div>
            </div>
        );
    }
}

export default PromptModal;
